<template>
    <div>
        <template
            v-for="(segment,i) in Insights.nav.Segment.current"
        >
            <v-divider
                v-if="i > 0"
                :key="segment.Path + '/divider'"
            ></v-divider>
            <segment-content
                :key="segment.Path + '/segment_content'"
                :Segment="segment"
                :Content="Insights.nav.Content.items.filter(item => item.SegmentKey === segment.SegmentKey)"
            ></segment-content>
        </template>
    </div>
</template>

<script>
import Insights from '../models/Insights'
import SegmentContent from './Segment.Content'

export default {
    components:{
        SegmentContent
    },
    data(){
        return {
            Insights
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
